import React, { Component } from 'react'
import { Input, Label, Menu, Button, Dropdown, Icon, Form, Flag, } from 'semantic-ui-react'
import { firebaseAuth, base, logDashboardAction } from '../../config/constants.js'
import Status from '../../config/OrderStatusConstants.js'
import { Link } from 'react-router-dom';
import { logout } from '../../Utilities/FireBaseUtils'

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


function RenderMenuItem(props) {

  const menuItem = props.orderSize > 0
    ? <Menu.Item name={props.name} onClick={props.handleItemClick}>
      <Label color={props.color}>{props.orderSize}</Label>
      {props.menuText}
    </Menu.Item>
    : ''


  return (
    <div>
      {menuItem}
    </div>
  )
}

export default class SideMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: 'inbox',
      newOrders: [],
      confirm_orderOrders: [],
      customer_contactedOrders: [],
      //CRANES
      cranesOrders: [],
      //DESIGN
      designingOrders: [],
      ready_to_designOrders: [],
      designing_startedOrders: [],
      new_design_addedOrders: [],
      clnt_chckng_dsgnOrders: [],
      clnt_rejectd_dsgnOrders: [],
      clnt_apprvd_dsgnOrders: [],
      start_dsng_scrnOrders: [],
      fin_dsng_scrnOrders: [],
      //verifiedOrders: [],
      allOrders: [],
      //usersOrders: [],
      screen_printingOrders: [],
      printingOrders: [],
      packingOrders: [],
      outForDeliveryOrders: [],
      deliveredOrders: [],
      cancelledOrders: [],
      lostOrders: [],
      start_dsng_kimotoOrders: [],
      fin_dsng_kimotoOrders: [],
      // refusedOrders: [],
      find_shirtOrders: [],
      shirt_foundOrders: [],
      orderLength: 0,
      user: '',
      deposit_requestOrders: [],
      deposit_requestedOrders: [],
      kimoto_printedOrders: [],
      follow_upOrders: [],
    }
  }

  handleItemClick = (e, { name }) => {
    console.log("sdx4 +++++++++++ handleItemClick");
    this.props.udpateTableFunction(name);
    this.setState({ activeItem: name })
  };

  componentDidMount() {
    console.log("ordertable: componentDidMount++++++++: orderType:" + this.props.orderType);

    //GET USER
    firebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        //console.log("user is signed in:" + user.uid);
        this.setState({
          user: user
        })

        //SNYC ORDER
        base.syncState('orders', {
          context: this,
          asArray: true,
          state: 'usersOrders',
          queries: {
            orderByChild: 'claimedInfo/claimedBy/email',
            equalTo: this.state.user.email
          }
        });

        //GET USER FROM USER NODE
        // this.loadUserFromFB(user.uid);
      } else {
        console.log("user is NOT signed in:" + user.uid);
      }
    });
  }

  logOutUser = () => {
    console.log("+++++++logoutuser");
    //logout();
    //history.push('./dashboard')

    let email = this.props.user.email;
    logDashboardAction(email+" login (but logged out) ",email,null,"logOut")
    console.log("email:"+email);

    //firebaseAuth().signOut();

    firebaseAuth().signOut().then(function() {
      console.log('Signed Out');
      
      history.push("/login");
    }, function(error) {
      console.error('Sign Out Error', error);
    });
    
  }

  componentDidMount() {

    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'allOrders'
    });

    /**
   * NEW ORDERS
   */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'newOrders',
      queries: {
        orderByChild: 'status',
        equalTo: "new"
      }
    });

    /**
* CUSTOMER CONTACTED
*/
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'confirm_orderOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.confirm_order
      }
    });

    /**
 * CUSTOMER CONTACTED
 */
    // base.syncState('orders', {
    //   context: this,
    //   asArray: true,
    //   state: 'customer_contactedOrders',
    //   queries: {
    //     orderByChild: 'status',
    //     equalTo: Status.customer_contacted
    //   }
    // });

    /**
     * ready_to_design
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'ready_to_designOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.ready_to_design
      }
    });

    /**
     * designing_started
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'designing_startedOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.designing_started
      }
    });

    /**
     * new_design_added
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'new_design_addedOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.new_design_added
      }
    });

    /**
    * clnt_chckng_dsgn
    */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'clnt_chckng_dsgnOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.clnt_chckng_dsgn
      }
    });

    /**
     * clnt_rejectd_dsgn
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'clnt_rejectd_dsgnOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.clnt_rejectd_dsgn
      }
    });

    /**
     * clnt_apprvd_dsgn
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'clnt_apprvd_dsgnOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.clnt_apprvd_dsgn
      }
    });

    /**
     * start_dsng_scrn
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'start_dsng_scrnOrders',
      queries: {
        orderByChild: 'status',
        equalTo: 'start_dsng_scrn'
      }
    });

    /**
     * fin_dsng_scrn
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'fin_dsng_scrnOrders',
      queries: {
        orderByChild: 'status',
        equalTo: 'fin_dsng_scrn'
      }
    });

    /**
     * ORDERS BEING DESIGNED
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'designingOrders',
      queries: {
        orderByChild: 'status',
        equalTo: 'designing'
      }
    });

    /**
    * SCREEN PRINTING
    */
    // base.syncState('orders', {
    //   context: this,
    //   asArray: true,
    //   state: 'screen_printingOrders',
    //   queries: {
    //     orderByChild: 'status',
    //     equalTo: Status.screen_printing
    //   }
    // });

    /**
     * SHIRT PRINTING
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'printingOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.printing
      }
    });

    /**
     * PACKING
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'packingOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.packing
      }
    });

    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'outForDeliveryOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.out_delivery
      }
    });

    /**
     * DELIVERED ORDERS
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'deliveredOrders',
      queries: {
        orderByChild: 'status',
        equalTo: 'delivered'
      }
    });

    /**
   * CRANES ORDERS
   */
    // base.syncState('orders', {
    //   context: this,
    //   asArray: true,
    //   state: 'cranesOrders',
    //   queries: {
    //     orderByChild: 'itemType',
    //     equalTo: 'cranes'
    //   }
    // });


    /**
   * CANCELLED ORDERS
   */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'cancelledOrders',
      queries: {
        orderByChild: 'status',
        equalTo: 'cancelled'
      }
    });

    /**
   * LOST ORDERS
   */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'lostOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.lost
      }
    });

    /**
     * START DESIGNING KIMOTO
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'start_dsng_kimotoOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.start_dsng_kimoto
      }
    });

    /**
     * FINISH DESIGNING KIMOTO
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'fin_dsng_kimotoOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.fin_dsng_kimoto
      }
    });

    /**
     * REFUSED ORDERS
     */
    // base.syncState('orders', {
    //   context: this,
    //   asArray: true,
    //   state: 'refusedOrders',
    //   queries: {
    //     orderByChild: 'status',
    //     equalTo: Status.refused
    //   }
    // });

    /**
    * FIND SHIRT
    */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'find_shirtOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.find_shirt
      }
    });

    /**
    * SHIRT FOUND
    */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'shirt_foundOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.shirt_found
      }
    });

    /**
     * deposit_request
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'deposit_requestOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.deposit_request
      }
    });

    /**
     * deposit_request
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'deposit_requestedOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.deposit_requested
      }
    });

    /**
     * kimoto_printed
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'kimoto_printedOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.kimoto_printed
      }
    });


    /**
     * follow_up
     */
    base.syncState('orders', {
      context: this,
      asArray: true,
      state: 'follow_upOrders',
      queries: {
        orderByChild: 'status',
        equalTo: Status.follow_up
      }
    });


  }



  render() {
    const { activeItem } = this.state

    const menu = (
      <Menu size='large' vertical>
        <Menu.Item name='all' active={activeItem === 'all'} onClick={this.handleItemClick}>
          <Label color='blue'>{this.state.allOrders.length}</Label>
          All
        </Menu.Item>

        {/* <Menu.Item name='yours' active={activeItem === 'updates'} onClick={this.handleItemClick}>
          <Label color='green'>{this.state.usersOrders.length}</Label>
          Yours
        </Menu.Item> */}

        {/* NEW ORDERS */}
        {/* <Menu.Item name='new' active={activeItem === 'inbox'} onClick={this.handleItemClick}>
          <Label color={Status.new_Color}>{this.state.newOrders.length}</Label>
          New
        </Menu.Item> */}

        <RenderMenuItem
          name={'new'}
          handleItemClick={this.handleItemClick}
          color={Status.new_Color}
          orderSize={this.state.newOrders.length}
          menuText='New' />

        <RenderMenuItem
          name={Status.confirm_order}
          handleItemClick={this.handleItemClick}
          color={Status.confirm_order_color}
          orderSize={this.state.confirm_orderOrders.length}
          menuText='ConfirmOrders' />

        <RenderMenuItem
          name={Status.follow_up}
          handleItemClick={this.handleItemClick}
          color={Status.follow_up_color}
          orderSize={this.state.follow_upOrders.length}
          menuText='Follow UP' />

        {/* DEPOSIT REQUEST */}
        <RenderMenuItem
          name={Status.deposit_request}
          handleItemClick={this.handleItemClick}
          color={Status.deposit_request_color}
          orderSize={this.state.deposit_requestOrders.length}
          menuText='Request Dep' />

        {/* DEPOSIT REQUESTED */}
        <RenderMenuItem
          name={Status.deposit_requested}
          handleItemClick={this.handleItemClick}
          color={Status.deposit_request_color}
          orderSize={this.state.deposit_requestedOrders.length}
          menuText='Dep Requested' />

        {/* <RenderMenuItem
          name={'cranes'}
          handleItemClick={this.handleItemClick}
          color={Status.new_Color}
          orderSize={this.state.cranesOrders.length}
          menuText='Cranes' /> */}

        {/* CUSTOMER CONTACTED*/}
        <RenderMenuItem
          name={Status.customer_contacted}
          handleItemClick={this.handleItemClick}
          color={Status.customer_contacted_color}
          orderSize={this.state.customer_contactedOrders.length}
          menuText='Cust Cont' />

        {/* ready to design */}
        <RenderMenuItem
          name={Status.ready_to_design}
          handleItemClick={this.handleItemClick}
          color={Status.ready_to_design_color}
          orderSize={this.state.ready_to_designOrders.length}
          menuText='Ready For Design' />

        {/* designing_started */}
        <RenderMenuItem
          name={Status.designing_started}
          handleItemClick={this.handleItemClick}
          color={Status.ready_to_design_color}
          orderSize={this.state.designing_startedOrders.length}
          menuText='Design Started' />

        {/* new_design_added */}
        <RenderMenuItem
          name={Status.new_design_added}
          handleItemClick={this.handleItemClick}
          color={Status.new_design_added_color}
          orderSize={this.state.new_design_addedOrders.length}
          menuText='*new Design Added' />

        {/* clnt checking design */}
        <RenderMenuItem
          name={Status.clnt_chckng_dsgn}
          handleItemClick={this.handleItemClick}
          color={Status.clnt_chckng_dsgn_color}
          orderSize={this.state.clnt_chckng_dsgnOrders.length}
          menuText='Client Review' />

        {/* clnt rejected design */}
        <RenderMenuItem
          name={Status.clnt_rejectd_dsgn}
          handleItemClick={this.handleItemClick}
          color={Status.clnt_rejectd_dsgn_color}
          orderSize={this.state.clnt_rejectd_dsgnOrders.length}
          menuText='Client Rejected' />

        {/* clnt approved design */}
        <RenderMenuItem
          name={Status.clnt_apprvd_dsgn}
          handleItemClick={this.handleItemClick}
          color={Status.clnt_apprvd_dsgn_color}
          orderSize={this.state.clnt_apprvd_dsgnOrders.length}
          menuText='Client Approved' />

        {/* start_dsng_kimoto */}
        <RenderMenuItem
          name={Status.start_dsng_kimoto}
          handleItemClick={this.handleItemClick}
          color={Status.start_dsng_kimoto_color}
          orderSize={this.state.start_dsng_kimotoOrders.length}
          menuText='Kimoto Needed' />

        {/* fin_dsng_kimoto */}
        <RenderMenuItem
          name={Status.fin_dsng_kimoto}
          handleItemClick={this.handleItemClick}
          color={Status.fin_dsng_kimoto_color}
          orderSize={this.state.fin_dsng_kimotoOrders.length}
          menuText='Finish Des Kimoto' />

        {/* KIMOTO PRINTED */}
        <RenderMenuItem
          name={Status.kimoto_printed}
          handleItemClick={this.handleItemClick}
          color={Status.kimoto_printed_color}
          orderSize={this.state.kimoto_printedOrders.length}
          menuText='Kimoto printed' />

        {/* find shirt */}
        <RenderMenuItem
          name={Status.find_shirt}
          handleItemClick={this.handleItemClick}
          color={Status.find_shirt_color}
          orderSize={this.state.find_shirtOrders.length}
          menuText='Find Shirt' />

        {/* shirt Found */}
        <RenderMenuItem
          name={Status.shirt_found}
          handleItemClick={this.handleItemClick}
          color={Status.find_shirt_color}
          orderSize={this.state.shirt_foundOrders.length}
          menuText='Shirt Avail' />

        {/* start screen printing */}
        {/* <RenderMenuItem
          name={Status.start_dsng_scrn}
          handleItemClick={this.handleItemClick}
          color={Status.start_dsng_scrn_color}
          orderSize={this.state.start_dsng_scrnOrders.length}
          menuText='Strt Srn prnt' /> */}

        {/* finish screen printing */}
        {/* <RenderMenuItem
          name={Status.fin_dsng_scrn}
          handleItemClick={this.handleItemClick}
          color={Status.fin_dsng_scrn_color}
          orderSize={this.state.fin_dsng_scrnOrders.length}
          menuText='Fin Scrn Prnt' /> */}


        {/* IN DESIGN */}
        {/* <RenderMenuItem
          name={Status.designing}
          handleItemClick={this.handleItemClick}
          color={Status.designing_color}
          orderSize={this.state.designingOrders.length}
          menuText='In Design' /> */}

        {/* SCREEN PRINTING */}
        {/* <RenderMenuItem
          name={Status.screen_printing}
          handleItemClick={this.handleItemClick}
          color={Status.screen_printing_color}
          orderSize={this.state.screen_printingOrders.length}
          menuText='Scr Prnt' /> */}

        {/* SHIRT PRINTING */}
        <RenderMenuItem
          name={Status.printing}
          handleItemClick={this.handleItemClick}
          color={Status.printing_color}
          orderSize={this.state.printingOrders.length}
          menuText='Printing' />

        {/* SHIRT packing */}
        <RenderMenuItem
          name={Status.packing}
          handleItemClick={this.handleItemClick}
          color={Status.packing_color}
          orderSize={this.state.packingOrders.length}
          menuText='Packing' />

        {/* outForDelivery */}
        <RenderMenuItem
          name={Status.out_delivery}
          handleItemClick={this.handleItemClick}
          color={Status.out_delivery_color}
          orderSize={this.state.outForDeliveryOrders.length}
          menuText='Delivery' />
        {/* SUPPLIES */}
        {/* <Menu.Item>
        <Link to={'/dashboard/supplies'}>SUPPLIES</Link>
        </Menu.Item> */}

        {/* CRANES HOME */}
        {/* <Menu.Item>
          <Link to={'/dashboard/cranes'}><Flag name='ug' />CRANES</Link>
        </Menu.Item> */}


        {/* CRANES HOME */}
        <Menu.Item>
          <Link to={'/dashboard/deposits'}><Icon name='money' />PAID DEPOSITS</Link>
        </Menu.Item>

        {/* CRANES HOME */}
        {/* <Menu.Item>
          <Link to={'/dashboard/ViewDepNotReq'}><Icon name='money' />DEP NOT REQ</Link>
        </Menu.Item> */}

        {/* CRANES HOME */}
        {/* <Menu.Item>
          <Link to={'/dashboard/jerseys'}><Icon name='soccer' />JERSEYS</Link>
        </Menu.Item> */}

        {/* SEARCH */}
        {/* <Menu.Item>
          <Link to={'/dashboard/search'}>SEARCH</Link>
        </Menu.Item> */}

        <Menu.Item>
          <Button onClick={this.logOutUser} type='button'>LOGOUT</Button>
        </Menu.Item>

        <Dropdown item text='More'>
          <Dropdown.Menu>

            {/* repl */}
            {/* <Dropdown.Item icon='edit' text='Edit Profile' >
              <Link to={'/dashboard/cranesReplacements'}>cranesReplacements</Link>
            </Dropdown.Item> */}

            {/* URGENT */}
            {/* <Dropdown.Item icon='edit' text='Edit Profile' >
              <Link to={'/dashboard/urgent'}>URGENT</Link>
            </Dropdown.Item> */}

            {/* archives */}
            <Dropdown.Item icon='edit' text='Archives' >
              <Link to={'/dashboard/viewArchives'}>ARCHIVES</Link>
            </Dropdown.Item>

            {/* returned orders */}
            {/* <Dropdown.Item icon='edit' text='Customer Pick Up' >
              <Link to={'/dashboard/customerPickUp'}>Customer Pick Up</Link>
            </Dropdown.Item> */}

            {/* returned orders */}
            {/* <Dropdown.Item icon='edit' text='View Shirts Needed' >
              <Link to={'/dashboard/countShirts'}>Shirts Needed</Link>
            </Dropdown.Item> */}

            {/* returned orders */}
            {/* <Dropdown.Item icon='edit' text='View Shirts Needed' >
              <Link to={'/dashboard/footballShirtsNeeded'}>Football Shirts</Link>
            </Dropdown.Item> */}

            {/* find shirts to Tag */}
            <Dropdown.Item icon='edit' text='Tag Shirts' >
              <Link to={'/dashboard/findShirtsToTag'}>Tag Shirts</Link>
            </Dropdown.Item>

            {/* find shirts to Tag */}
            <Dropdown.Item icon='edit' text='PinkTie' >
              <Link to={'/dashboard/pinkTieOrders'}>PINK TIE ORDERS</Link>
            </Dropdown.Item>

            {/* find shirts to Tag */}
            <Dropdown.Item icon='edit' text='PinkTie' >
              <Link to={'/viewOrder'}>VIEW SINGLE ORDER</Link>
            </Dropdown.Item>

            {/* cups */}
            <Dropdown.Item icon='edit' text='View Cups' >
              <Link to={'/dashboard/cups'}>Cups</Link>
            </Dropdown.Item>

            {/* jumpers */}
            <Dropdown.Item icon='edit' text='View Jumpers' >
              <Link to={'/dashboard/jumpers'}>Jumpers</Link>
            </Dropdown.Item>

            {/* jumpers */}
            <Dropdown.Item icon='edit' text='View Deposits' >
              <Link to={'/dashboard/deposits'}>Deposits Made</Link>
            </Dropdown.Item>

            {/* SINIYA */}
            {/* <Dropdown.Item icon='edit' text='Siniya' >
              <Link to={'/dashboard/siniya'}>VIEW SINIYA ORDERS</Link>
            </Dropdown.Item> */}

            {/* BOXERS */}
            <Dropdown.Item icon='edit' text='Boxers' >
              <Link to={'/dashboard/viewServerResultsGet/shirts_getOrderByShirtType_boxer'}>VIEW BOXERS </Link>
            </Dropdown.Item>

            {/* THONG */}
            <Dropdown.Item icon='edit' text='Thongs' >
              <Link to={'/dashboard/viewServerResultsGet/shirts_getOrderByShirtType_thong'}>VIEW THONGS </Link>
            </Dropdown.Item>

            {/* HEAT PRESS */}
            <Dropdown.Item icon='edit' text='heat press' >
              <Link to={'/dashboard/viewServerResults/shirts_findHeatPressOrders'}>HEAT PRESS </Link>
            </Dropdown.Item>

            {/* VINYL */}
            <Dropdown.Item icon='edit' text='vinyl' >
              <Link to={'/dashboard/viewServerResults/shirts_findVinylOrders'}>VINYL </Link>
            </Dropdown.Item>

            {/* OLD ORDERS */}
            <Dropdown.Item icon='edit' text='Thongs' >
              <Link to={'/dashboard/viewServerResults/orders_findOrdersNotUpdateInThreeDays'}>LATE ORDERS </Link>
            </Dropdown.Item>

            {/* NO ORDER TYPE*/}
            <Dropdown.Item icon='edit' text='Thongs' >
              <Link to={'/dashboard/viewServerResults/orders_findOrdersNotUpdateInThreeDays'}>NO ORDER TYPE</Link>
            </Dropdown.Item>

            {/* VIEW LATE ORDERS */}
            <Dropdown.Item icon='edit' text='Thongs' >
              <Link to={'/dashboard/viewServerResults/orders_findOrdersDueInXDays'}>orders x ORDERS </Link>
            </Dropdown.Item>

            {/* LOST */}
            <Dropdown.Item icon='edit' text='Edit Profile' >
              <RenderMenuItem
                name={Status.lost}
                handleItemClick={this.handleItemClick}
                color={Status.lost_color}
                orderSize={this.state.lostOrders.length}
                menuText='Lost' />
            </Dropdown.Item>

            {/* CANCELLED */}
            <Dropdown.Item icon='edit' text='Edit Profile' >
              <RenderMenuItem
                name={Status.cancelled}
                handleItemClick={this.handleItemClick}
                color={Status.cancelled_color}
                orderSize={this.state.cancelledOrders.length}
                menuText='Cancelled' />
            </Dropdown.Item>

            {/* finished */}
            <Dropdown.Item icon='edit' text='Edit Profile' >

              <RenderMenuItem
                name={Status.delivered}
                handleItemClick={this.handleItemClick}
                color={Status.delivered_color}
                orderSize={this.state.deliveredOrders.length}
                menuText='Finished' />
            </Dropdown.Item>


            {/* returned Orders */}
            {/* <Dropdown.Item icon='edit' text='Edit Profile' >

              <RenderMenuItem
                name={Status.refused}
                handleItemClick={this.handleItemClick}
                color={Status.refused_color}
                orderSize={this.state.refusedOrders.length}
                menuText='Refused' />
            </Dropdown.Item> */}
          </Dropdown.Menu>
        </Dropdown>

        {/* <Menu.Item>
          <Form onSubmit={this.props.searchNumber}>
            <Input icon='search' name='searchNumberText' onChange={this.props.handleTextChange} placeholder='Search number' />
          </Form>
        </Menu.Item> */}

      </Menu>
    )
    return (
      <div>
        {menu}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/SideMenu.js